import siteConfig from "../config/siteConfig";

const topSizes = ["XS", "S", "M", "L", "XL", "XXL"];
const trouserSizes = ["28", "30", "32", "34", "36", "38", "40"];
const shoeSizes = ["7", "8", "9", "10", "11", "12", "13"];

const products = [
  {
    id: 1,
    name: "Willow Jacket",
    category: "Jackets",
    price: 160,
    colors: ["Slate Blue", "Sand"],
    sizes: topSizes,
    image: "/img/products/product-01.jpg",
    material: "Organic cotton twill",
    fit: "Straight fit",
    description:
      "A quietly structured workwear jacket cut from supple organic cotton twill. Its clean patch pockets and softly washed finish make it an easy layer from spring through early autumn.",
    features: ["Button front", "Three exterior pockets", "Garment washed", "Made in Portugal"],
    tags: ["new", "essentials", "outerwear"],
  },
  {
    id: 2,
    name: "Cedar Blouson",
    category: "Jackets",
    price: 175,
    colors: ["Warm Sand", "Dark Khaki"],
    sizes: topSizes,
    image: "/img/products/product-02.jpg",
    material: "Brushed cotton",
    fit: "Relaxed fit",
    description:
      "A light blouson with the softness of suede and the ease of cotton. The compact collar, elasticated hem and discreet pockets give it a refined, uncomplicated profile.",
    features: ["Two-way zip", "Side welt pockets", "Cotton lining", "Elasticated hem"],
    tags: ["new", "outerwear", "summer"],
  },
  {
    id: 3,
    name: "Fern Herringbone Jacket",
    category: "Jackets",
    price: 450,
    colors: ["Olive Herringbone", "Tobacco"],
    sizes: topSizes,
    image: "/img/products/product-03.jpg",
    material: "Wool and linen blend",
    fit: "Tailored fit",
    description:
      "A softly tailored jacket designed with an unstructured shoulder and tactile herringbone weave. Wool adds shape while linen keeps the cloth breathable and relaxed.",
    features: ["Half canvas construction", "Two-button closure", "Half lined", "Interior pocket"],
    tags: ["new", "tailoring", "occasion"],
  },
  {
    id: 4,
    name: "Grove Suit Jacket",
    category: "Jackets",
    price: 440,
    colors: ["Deep Navy", "Charcoal"],
    sizes: topSizes,
    image: "/img/products/product-04.jpg",
    material: "Italian virgin wool",
    fit: "Regular tailored fit",
    description:
      "A double-breasted jacket with generous peak lapels and a naturally elegant drape. Fine Italian wool gives the cloth a crisp hand without sacrificing comfort.",
    features: ["Double-breasted front", "Horn-effect buttons", "Double vent", "Fully lined"],
    tags: ["tailoring", "occasion", "limited"],
  },
  {
    id: 5,
    name: "Linden Stripe Shirt",
    category: "Shirts",
    price: 130,
    colors: ["Blue White Stripe", "White"],
    sizes: ["37", "38", "39", "40", "41", "42", "44"],
    image: "/img/products/product-05.jpg",
    material: "Organic cotton poplin",
    fit: "Classic fit",
    description:
      "A precise striped shirt with a semi-cutaway collar and clean French placket. The compact organic cotton poplin remains crisp while softening beautifully over time.",
    features: ["Mother-of-pearl buttons", "Curved hem", "Single-button cuff", "OEKO-TEX certified"],
    tags: ["new", "essentials", "workwear"],
  },
  {
    id: 6,
    name: "Meadow Cotton Linen Shirt",
    category: "Shirts",
    price: 130,
    colors: ["Ecru", "Sky Blue"],
    sizes: topSizes,
    image: "/img/products/product-06.jpg",
    material: "Cotton and linen",
    fit: "Relaxed fit",
    description:
      "The ease of linen meets the softness of cotton in a warm-weather shirt with an open collar and relaxed line. Designed to be worn tucked or loose.",
    features: ["Camp collar", "French seams", "Straight hem", "Light garment wash"],
    tags: ["new", "summer", "shirts"],
  },
  {
    id: 7,
    name: "Sage Casual Shirt",
    category: "Shirts",
    price: 160,
    colors: ["Sage", "Stone"],
    sizes: topSizes,
    image: "/img/products/product-07.jpg",
    material: "Cotton canvas",
    fit: "Overshirt fit",
    description:
      "A versatile overshirt in soft cotton canvas, finished with understated utility pockets. Wear it buttoned as a shirt or open as a light layer.",
    features: ["Two chest pockets", "Reinforced seams", "Corozo buttons", "Garment dyed"],
    tags: ["new", "overshirt", "essentials"],
  },
  {
    id: 8,
    name: "Breeze Mesh Shirt",
    category: "Shirts",
    price: 145,
    colors: ["Navy", "Natural"],
    sizes: topSizes,
    image: "/img/products/product-08.jpg",
    material: "Open-knit organic cotton",
    fit: "Easy fit",
    description:
      "An airy short-sleeve shirt knitted in a discreet open texture. A tonal underlayer and neat collar keep the summer silhouette polished rather than sheer.",
    features: ["Open-knit texture", "Ribbed collar", "Button front", "Breathable construction"],
    tags: ["new", "summer", "knitwear"],
  },
  {
    id: 9,
    name: "Sorrel Knit Polo",
    category: "Knitwear",
    price: 130,
    colors: ["Burgundy", "Navy"],
    sizes: topSizes,
    image: "/img/products/product-09.jpg",
    material: "Cotton and silk",
    fit: "Regular fit",
    description:
      "A finely textured polo knitted from breathable cotton with a touch of silk. The open placket and relaxed collar create an effortless line.",
    features: ["Open placket", "Fine gauge knit", "Ribbed hem", "Responsible yarn"],
    tags: ["new", "summer", "polos"],
  },
  {
    id: 10,
    name: "Iris Knit Polo",
    category: "Knitwear",
    price: 130,
    colors: ["Cream Navy", "Ecru"],
    sizes: topSizes,
    image: "/img/products/product-10.jpg",
    material: "Organic cotton",
    fit: "Relaxed fit",
    description:
      "A vintage-minded knit polo with restrained contrast tipping and a comfortable, slightly relaxed shape. The soft cotton yarn makes it ideal for warm days.",
    features: ["Contrast tipping", "Three-button placket", "Ribbed finish", "Mid-weight knit"],
    tags: ["new", "polos", "summer"],
  },
  {
    id: 11,
    name: "Moss Knit Polo",
    category: "Knitwear",
    price: 130,
    colors: ["Forest Green", "Camel"],
    sizes: topSizes,
    image: "/img/products/product-11.jpg",
    material: "Mercerised cotton",
    fit: "Slim regular fit",
    description:
      "A clean polo in a subtle seed stitch with a compact collar. Mercerised cotton lends depth to the color and a smooth, cool handle.",
    features: ["Seed-stitch knit", "Shell-effect buttons", "Ribbed cuffs", "Shape-retaining yarn"],
    tags: ["new", "polos", "smart-casual"],
  },
  {
    id: 12,
    name: "Hazel Merino Sweater",
    category: "Knitwear",
    price: 130,
    colors: ["Camel", "Navy", "Grey Marl"],
    sizes: topSizes,
    image: "/img/products/product-12.jpg",
    material: "Extra-fine merino wool",
    fit: "Regular fit",
    description:
      "A dependable crewneck in extra-fine merino wool, knitted densely enough to hold its shape while remaining light and comfortable against the skin.",
    features: ["12-gauge merino", "Fully fashioned seams", "Ribbed trims", "Woolmark certified"],
    tags: ["essentials", "knitwear", "layering"],
  },
  {
    id: 13,
    name: "Heather Stitch Sweater",
    category: "Knitwear",
    price: 175,
    colors: ["Slate Blue", "Burgundy", "Navy"],
    sizes: topSizes,
    image: "/img/products/product-13.jpg",
    material: "Merino wool",
    fit: "Comfort fit",
    description:
      "A tactile honeycomb sweater in warm merino wool. The dimensional stitch brings character to a straightforward, easy-to-layer shape.",
    features: ["Honeycomb stitch", "Crew neck", "Ribbed cuffs", "Naturally breathable"],
    tags: ["essentials", "knitwear", "texture"],
  },
  {
    id: 14,
    name: "Clay Heavyweight T-Shirt",
    category: "T-Shirts",
    price: 90,
    colors: ["Washed Terracotta", "Off White"],
    sizes: topSizes,
    image: "/img/products/product-14.jpg",
    material: "Heavyweight organic cotton",
    fit: "Boxy fit",
    description:
      "A substantial jersey T-shirt with a softly faded surface and balanced boxy proportions. Built to wear well alone and beneath relaxed tailoring.",
    features: ["240gsm jersey", "Bound crew neck", "Garment dyed", "Pre-washed"],
    tags: ["new", "t-shirts", "essentials"],
  },
  {
    id: 15,
    name: "Petal Knit T-Shirt",
    category: "T-Shirts",
    price: 125,
    colors: ["Ivory Navy", "Sand"],
    sizes: topSizes,
    image: "/img/products/product-15.jpg",
    material: "Fine cotton knit",
    fit: "Regular fit",
    description:
      "A polished alternative to jersey, knitted in fine cotton and framed with subtle contrast edges. Soft, breathable and easy beneath a jacket.",
    features: ["Fine gauge knit", "Contrast ribbing", "Fully fashioned", "Machine washable"],
    tags: ["new", "t-shirts", "knitwear"],
  },
  {
    id: 16,
    name: "Sky Cotton T-Shirt",
    category: "T-Shirts",
    price: 85,
    colors: ["Powder Blue", "White"],
    sizes: topSizes,
    image: "/img/products/product-16.jpg",
    material: "Long-staple cotton jersey",
    fit: "Straight fit",
    description:
      "A refined everyday T-shirt in smooth long-staple cotton. Neat proportions and a resilient neckline make it a foundation piece for every season.",
    features: ["Compact jersey", "Reinforced neckline", "Twin-needle hem", "Soft enzyme wash"],
    tags: ["essentials", "t-shirts", "layering"],
  },
  {
    id: 17,
    name: "Arbor Straight Pants",
    category: "Trousers",
    price: 150,
    colors: ["Tobacco", "Olive", "Navy"],
    sizes: trouserSizes,
    image: "/img/products/product-17.jpg",
    material: "Cotton linen twill",
    fit: "Straight leg",
    description:
      "Straight-leg trousers with a clean waist and a relaxed break. The cotton-linen twill has enough structure for tailoring and enough ease for everyday wear.",
    features: ["Mid rise", "Single pleat", "Slant pockets", "Clean blind hem"],
    tags: ["new", "trousers", "summer"],
  },
  {
    id: 18,
    name: "Stonepath Suit Pants",
    category: "Trousers",
    price: 180,
    colors: ["Charcoal", "Deep Navy"],
    sizes: trouserSizes,
    image: "/img/products/product-18.jpg",
    material: "Virgin wool",
    fit: "Tailored straight leg",
    description:
      "A composed suit trouser with a gently extended waistband and fluid straight leg. Fine wool ensures a clean drape from office to evening.",
    features: ["Extended tab closure", "Pressed crease", "Back welt pockets", "Knee lined"],
    tags: ["tailoring", "trousers", "occasion"],
  },
  {
    id: 19,
    name: "Riverbend Jeans",
    category: "Jeans",
    price: 145,
    colors: ["Mid Wash", "Raw Denim", "Ecru"],
    sizes: ["27", "28", "29", "30", "31", "32", "33", "34", "36", "38"],
    image: "/img/products/product-19.jpg",
    material: "Organic cotton denim",
    fit: "Straight leg",
    description:
      "A modern straight jean with an easy rise and subtle vintage wash. Rigid organic denim softens with wear and develops a personal patina.",
    features: ["Five pockets", "Button fly", "13oz denim", "Low-impact wash"],
    tags: ["essentials", "jeans", "denim"],
  },
  {
    id: 20,
    name: "Briar Derbies",
    category: "Shoes",
    price: 325,
    colors: ["Dark Cognac", "Black"],
    sizes: shoeSizes,
    image: "/img/products/product-20.jpg",
    material: "Polished calf leather",
    fit: "True to size",
    description:
      "Elegant plain-toe derbies shaped on a softly rounded last. Polished calf leather and a welted construction balance formality with everyday durability.",
    features: ["Leather lining", "Welted sole", "Stacked heel", "Made in Portugal"],
    tags: ["shoes", "tailoring", "leather"],
  },
  {
    id: 21,
    name: "Oakshade Loafers",
    category: "Shoes",
    price: 390,
    colors: ["Deep Brown", "Black"],
    sizes: shoeSizes,
    image: "/img/products/product-21.jpg",
    material: "Full-grain calf leather",
    fit: "Slightly generous",
    description:
      "A supple penny loafer with an understated apron seam and flexible leather sole. Designed to look equally natural with denim or relaxed tailoring.",
    features: ["Hand-finished leather", "Leather sole", "Padded heel", "Blake stitched"],
    tags: ["new", "shoes", "leather"],
  },
  {
    id: 22,
    name: "Dune Espadrilles",
    category: "Shoes",
    price: 110,
    colors: ["Natural", "Navy"],
    sizes: shoeSizes,
    image: "/img/products/product-22.jpg",
    material: "Cotton canvas and jute",
    fit: "True to size",
    description:
      "A warm-weather espadrille made with sturdy cotton canvas and a hand-braided jute sole. Lightweight, flexible and simple by design.",
    features: ["Canvas upper", "Braided jute midsole", "Rubber outsole", "Cotton lining"],
    tags: ["new", "shoes", "summer"],
  },
  {
    id: 23,
    name: "Trellis Patchwork Belt",
    category: "Accessories",
    price: 100,
    colors: ["Patchwork Brown", "Dark Brown"],
    sizes: ["85", "90", "95", "100", "105"],
    image: "/img/products/product-23.jpg",
    material: "Vegetable-tanned leather",
    fit: "3.2cm width",
    description:
      "A characterful belt assembled from tonal strips of vegetable-tanned leather. Each piece will deepen in color and become more individual with wear.",
    features: ["Brushed brass buckle", "Hand-finished edges", "Five holes", "Made in Italy"],
    tags: ["accessories", "leather", "gift"],
  },
  {
    id: 24,
    name: "Wayfarer Weekend Bag",
    category: "Accessories",
    price: 470,
    colors: ["Cognac", "Dark Chocolate"],
    sizes: ["One size"],
    image: "/img/products/product-24.jpg",
    material: "Grained calf leather",
    fit: "48 × 31 × 22cm",
    description:
      "A generous weekender with a clean, soft-sided silhouette. Durable grained leather, reinforced handles and an organized cotton-lined interior are built for years of travel.",
    features: ["Detachable shoulder strap", "Interior zip pocket", "Protective feet", "Cotton canvas lining"],
    tags: ["accessories", "leather", "travel"],
  },
  {
    id: 25,
    name: "Juniper Field Jacket",
    category: "Jackets",
    price: 195,
    colors: ["Garden Olive", "Warm Stone"],
    sizes: topSizes,
    image: "/img/products/product-25.jpg",
    material: "Cotton and hemp canvas",
    fit: "Relaxed straight fit",
    description:
      "A practical field jacket in breathable cotton-hemp canvas, softened for immediate comfort. Four balanced utility pockets and an unlined construction make it an easy layer across seasons.",
    features: ["Four utility pockets", "Unlined construction", "Corozo buttons", "Garment washed"],
    tags: ["new", "outerwear", "essentials"],
  },
  {
    id: 26,
    name: "Orchard Oxford Shirt",
    category: "Shirts",
    price: 120,
    colors: ["Pale Blue", "Soft White"],
    sizes: topSizes,
    image: "/img/products/product-26.jpg",
    material: "Organic cotton Oxford",
    fit: "Comfort fit",
    description:
      "A softly structured Oxford shirt with an easy collar and a clean everyday line. The organic cotton cloth is substantial yet breathable and becomes more supple with every wear.",
    features: ["Button-down collar", "Single chest pocket", "Box pleat", "Garment washed"],
    tags: ["new", "shirts", "essentials"],
  },
  {
    id: 27,
    name: "Cypress Pleated Trousers",
    category: "Trousers",
    price: 165,
    colors: ["Forest Green", "Charcoal"],
    sizes: trouserSizes,
    image: "/img/products/product-27.jpg",
    material: "Responsible wool twill",
    fit: "Relaxed tapered leg",
    description:
      "Single-pleat trousers shaped with a comfortable rise and a softly tapered leg. Responsible wool twill gives the silhouette a clean drape while remaining comfortable throughout the day.",
    features: ["Single front pleat", "Extended waistband", "Pressed crease", "Half lined"],
    tags: ["new", "trousers", "tailoring"],
  },
  {
    id: 28,
    name: "Gardenia Canvas Tote",
    category: "Accessories",
    price: 135,
    colors: ["Natural Forest", "Natural Tobacco"],
    sizes: ["One size"],
    image: "/img/products/product-28.jpg",
    material: "Heavy cotton canvas and leather",
    fit: "42 × 32 × 15cm",
    description:
      "A structured everyday tote pairing durable natural canvas with full-grain leather handles. Its open interior and secure slip pocket keep work, market and travel essentials close at hand.",
    features: ["Reinforced leather handles", "Interior slip pocket", "Structured base", "Cotton lining"],
    tags: ["new", "accessories", "travel"],
  },
];

const productData = products.map((product) => ({
  ...product,
  brand: siteConfig.brandName,
  images: product.images || [product.image],
  attributes: {
    sizes: product.sizes,
    colors: product.colors,
    material: product.material,
    fit: product.fit,
    care:
      product.category === "Shoes" || product.category === "Accessories"
        ? "Wipe clean with a soft, dry cloth"
        : "Follow the care label and air between wears",
  },
}));

export const productCategories = [
  "All",
  "Jackets",
  "Shirts",
  "Knitwear",
  "T-Shirts",
  "Trousers",
  "Jeans",
  "Shoes",
  "Accessories",
];

export default productData;
